module.exports = __webpack_public_path__ + "static/media/tutorial-photos-background.ae7c84fb.svg";